import { z } from "zod";
import { batchCalculationRequestSchema, batchCalculationResponseSchema } from "./calculation.js";
// Interactive simulations retain the existing runtime item and response contract.
export const lotSimulationRequestSchema = z
    .object({
    calculationDate: batchCalculationRequestSchema.shape.calculationDate,
    rulesetSelector: batchCalculationRequestSchema.shape.rulesetSelector,
    items: batchCalculationRequestSchema.shape.items,
})
    .strict()
    .superRefine((input, ctx) => {
    for (const field of ["itemId", "position"]) {
        if (new Set(input.items.map((item) => item[field])).size !== input.items.length) {
            ctx.addIssue({ code: "custom", path: ["items"], message: `${field} must be unique` });
        }
    }
});
export const lotSimulationResponseSchema = z
    .object({
    mode: z.literal("SIMULATION"),
    request: batchCalculationRequestSchema,
    result: batchCalculationResponseSchema,
})
    .strict();
//# sourceMappingURL=lot-simulation.js.map